module.exports = __webpack_public_path__ + "img/more-notes-icon.66cc2939.svg";